import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-6" }
const _hoisted_2 = { class: "flex flex-col" }

import { watch } from "vue"
import { ClockIcon } from "@heroicons/vue/outline"
import { useWorkflowStore } from "@/stores/workflow"
import { CalendarNodeType } from "@/shared/models/workflow"
import GgmsMultiSelect from "@/components/GgmsMultiSelect.vue"
import GgmsRadioSelect from "@/components/GgmsRadioSelect.vue"
import GgmsCalendar from "@/components/GgmsCalendar.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'WeekDaysComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()

const daysOptions = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]

const radioButtonsOptions = [
    { displayName: "Delay until the same time of day that the contact entered the delay", value: "now" },
    { displayName: "Specific time", value: "time" },
]

watch(
    () => workflowStore.modelValue.event,
    () => {
        if (workflowStore.modelValue.event !== "time") {
            workflowStore.modelValue.time = ""
        }
    }
)

watch(
    () => [workflowStore.modelValue.days, workflowStore.modelValue.event, workflowStore.modelValue.time],
    () => {
        workflowStore.areButtonDisabled =
            workflowStore.modelValue.days &&
            workflowStore.modelValue.event &&
            workflowStore.modelValue.event === "time" &&
            workflowStore.modelValue.time
                ? false
                : !(
                      workflowStore.modelValue.days &&
                      workflowStore.modelValue.event &&
                      workflowStore.modelValue.event !== "time"
                  )
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-lg leading-7 font-medium text-black" }, "Days of the week contacts should move to next action", -1)),
    _createVNode(GgmsMultiSelect, {
      modelValue: _unref(workflowStore).modelValue.days,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(workflowStore).modelValue.days) = $event)),
      options: daysOptions,
      placeholder: "Choose day or days",
      classes: "w-full"
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-sm text-gray-800 font-medium" }, "Time of day", -1)),
      _createVNode(GgmsRadioSelect, {
        modelValue: _unref(workflowStore).modelValue.event,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(workflowStore).modelValue.event) = $event)),
        options: radioButtonsOptions
      }, null, 8, ["modelValue"]),
      (_unref(workflowStore).modelValue.event === _unref(CalendarNodeType).time)
        ? (_openBlock(), _createBlock(GgmsCalendar, {
            key: 0,
            modelValue: _unref(workflowStore).modelValue.time,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(workflowStore).modelValue.time) = $event)),
            position: "below",
            class: "pt-4",
            label: "Select time",
            showTime: true,
            showDate: false,
            iconStart: _unref(ClockIcon)
          }, null, 8, ["modelValue", "iconStart"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})